module.exports = __webpack_public_path__ + "media/assets/images/kasai_first_view-28df4c1b1bf8174a2e1a44ee73b78fb8.svg";